module.exports = __webpack_public_path__ + "static/media/warning.32f4df42.svg";